<template>
    <div>
        <!-- 轮播图 -->
        <!-- <img src="@/assets/img/banner.jpg" style="width: 100%;" alt=""> -->
        <div id="swiper" class="container-fuild">
      <div class="swiper-container banner-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in swiperList" :key="index">
            <img class="swiper-lazy" :src="item.img" style="width: 100%;">
            <div class="swiper-lazy-preloader"></div>
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>

        <!-- 如果需要导航按钮 -->
        <!-- <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div> -->
      </div>
    </div>
        <div class="m-3">
            <!-- 视频 -->
            <div class="video">
                <video src="@/assets/video.mp4" controls  style="width: 100%; height: auto;"></video>
            </div>
            <!-- 关于我们 -->
            <div class="mt-3">
                <div class="flex-row justify-between align-center">
                    <div>
                        <div class="sub-title">About us</div>
                        <div class="title">关于我们</div>
                    </div>
                    <div>
                        <img src="@/assets/mimg/arrow.png" alt="" style="width: 50px;" @click="page('about')">
                    </div>
                </div>
                <div class="content-right basis-df flex-column justify-between" style="text-indent: 2rem;line-height: 30px;">
                    凡己科技（苏州）有限公司 是一家致力于电机控制器和永磁同步电机系统级方案、智能仪表和智能车机系统等产品的研发、生产与销售的高新技术企业。是专精特新“小巨人”企业，中国工业车辆行业协会理事单位，中国首个非道路电动控制器标准的主要起草单位。
                </div>
                <div class="content-right basis-df flex-column justify-between" style="text-indent: 2rem;line-height: 30px;">
                    公司自2011年成立至今，始终坚持以自主核心技术为客户服务，自主研发生产的电动车辆控制器、智能仪表、永磁电机、远程监控管理系统等系列产品，成功应用于电动叉车、电动仓储车、电动观光车、高尔夫球车、环卫车、高空作业平台、工程机械、农业、园林、电动轮椅车、船舶等领域。客户覆盖徐工、中联重科、JLG、合力、龙工、诺力、林德、台励福、中力、涛涛车业、戴尔乐等行业龙头企业，为全球非道路电动化的普及提供有价值的解决方案。
                 </div>
            </div>
            <!-- 产品中心 -->
            <div class="mt-3">
                <div class="flex-row justify-between align-center">
                    <div>
                        <div class="sub-title">Product</div>
                        <div class="title">产品中心</div>
                    </div>
                    <div>
                        <img src="@/assets/mimg/arrow.png" alt="" style="width: 50px;" @click="page('products')">
                    </div>
                </div>
                <div class="mt-1 flex-row flex-wrap justify-between">
                    <div   class="product-item" v-for="(item, index) in productsData">
                        <div class="product-img flex-row align-center justify-center">
                            <img :src="http.ipAddress+item.filePath"
                                style="width: 100px;height: 100px;" alt="" @click="pageproduct(item.productType,item.id)">
                        </div>
                        <div class="text-center mt-1">{{item.productName}}</div>
                    </div>
                </div>
            </div>
            <!-- 客户价值 -->
            <div class="mt-3">
                <div>
                    <div class="sub-title">Customer Value</div>
                    <div class="title">客户价值</div>
                </div>
                <div class="mt-1">
                    <div class="customer-item flex-row  justify-between" v-for="item in customersData">
                        <div class="customer-left flex-row   align-end" style="padding-bottom: 10px;text-align: left;">{{item.desc}}</div>
                        <div class="customer-right flex-column align-center justify-center">
                            <div style="font-size: 18px;">{{item.name}}</div>
                            <div style="font-size: 8px;">{{item.sub_name}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 成功案例 -->
            <div class="mt-3">

                <div class="flex-row justify-between align-center">
                    <div>
                        <div class="sub-title">Cases</div>
                        <div class="title">成功案例</div>
                    </div>
                    <div>
                        <img src="@/assets/mimg/arrow.png" alt="" style="width: 50px;" @click="page('cases')">
                    </div>
                </div>
                <div class="mt-1">
                    <div class="flex-row flex-wrap ">
                        <div @click="page('cases')" class="cases-item basis-df" v-for="(item, index) in customerData" style="border: none;">
                            <img :src="http.ipAddress+item.filePath"
                                style="width: 100%" alt="">
                          
                        </div>
                    </div>
                </div>
            </div>
            <!-- 项目咨询 -->
            <div class="mt-3">
                <div class="flex-row justify-between align-center">
                    <div>
                        <div class="title">项目咨询</div>
                        <div class="sub-title">Project consulting</div>
                    </div>
                    <div >
                        <!-- <img src="@/assets/mimg/more.png" @click="projectSubmit()" alt="" style="width: 100px;" > -->
                        <div class="sub-title" @click="projectSubmit()">提交</div>
                    </div>
                </div>
                <div class="mt-1">
                    <div class="flex-row flex-wrap">
                        <div class="project-item flex-row align-center justify-center" v-for="item in projectData" >
                            <div   style="margin-right: 2px;">{{ item.name }}</div>
                            <div>
                                <input class="input" @blur="judgeEmpty(item)" :class="{inputEmpty:item.error}" v-model="item.value" type="text">
                                <div v-if="item.name == '电话' && !item.validPhone" class="error-tip">电话格式不正确</div>
                                <div v-if="item.name == '邮箱' && !item.checkEmail" class="error-tip">邮箱格式不正确</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper";
// import { controllerData} from "../products/products";
export default {
    data() {
        return {
            value:"",
            swiperList: [
            {
                img: require("@/assets/img/m-banner.jpg"),
                path: "",
                title: '',
                content: '',
            },{
                img: require("@/assets/img/m-banner-1.jpg"),
                path: "",
                title: '',
                content: '',
            },
            ],
            customerData:[],
            productsData:[
                // {
                //     name:"FJ-D1系列电动车辆控制系统",
                //     img:"D1.png",
                //     path:"",
                //     switch:1,
                //     index:"0"
                // },{
                //     name:"FJ-G1系列电动车辆控制系统",
                //     img:"G1.png",
                //     path:"",
                //     switch:1,
                //     index:"1"
                // },{
                //     name:"FJ-S1X系列电动车辆控制系统",
                //     img:"S1X.png",
                //     path:"",
                //     switch:1,
                //     index:"5"
                // },{
                //     name:"FJ-S1系列电动车辆控制系统",
                //     img:"S1.png",
                //     path:"",
                //     switch:1,
                //     index:"6"
                // },{
                //     name:"FJ-S0系列电动车辆控制系统",
                //     img:"S0.png",
                //     path:"",
                //     switch:1,
                //     index:"3"
                // },{
                //     name:"FJ-M2仪表",
                //     img:"M2.png",
                //     path:"",
                //     switch:2,
                //     index:"2"
                // },
            ],
            customersData: [
                {
                    name: "敏捷",
                    sub_name: "Rapidly",
                    img: "S1X.png",
                    path: "",
                    desc: '对客户的应用需求做出快速响应'
                },
                {
                    name:"精湛",
                    sub_name:"Quality",
                    img:"S1X.png",
                    path:"",
                    desc:'安全可靠的产品、高效率的工艺质控'
                },
                {
                    name:"专业",
                    sub_name:"Advanced",
                    img:"S1X.png",
                    path:"",
                    desc:'国际领先的核心技术和先进测试能力'
                }
            ],
            projectData:[
                {
                    name:'公司',
                    value:"",
                    error:false
                },
                {
                    name:'行业',
                    value:"",
                    error:false
                },
                {
                    name:'姓名',
                    value:"",
                    error:false
                },
                {
                    name:'电话',
                    value:"",
                    error:false,
                    validPhone: true
                },
                {
                    name:'邮箱',
                    value:"",
                    error:false,
                    checkEmail: true
                },
                {
                    name:'职位',
                    value:"",
                    error:false
                }
            ]
        }
    },
    methods: {
        page(url) {
            this.$router.push('/' + url);
            
            
            this.$emit("fatherRedirect",url);
        },
        pageproduct(type,index) {
           
            this.$router.push({path:'/productsDetail', query: {switch:type,index}});
        },
        judgeEmpty(item){
            debugger

            if (item.name === '电话') {
        const re = /^(\+\d{1,4})?(\d{8,11})$/;
        item.validPhone = re.test(item.value);
      } else if (item.name === '邮箱') {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        item.checkEmail = re.test(item.value);
      }
      item.error = item.value === "";

            if(item.value==null||item.value==""){
                item.error=true;
            }else{
                item.error=false;
            }
            if (item.value == "") {
        item.error = true;
    } else {
        item.error = false;
        if (item.name == "邮箱") {
            let regExp = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
            item.checkEmail = regExp.test(item.value);
        }
    }
        },
        projectSubmit(){
            debugger

            for (let item of this.projectData) {
                this.judgeEmpty(item);}

            let projectConsult={};
            let checkResult=true;
            this.projectData.forEach(item => {
                if(item.value==null||item.value==""){
                    item.error=true;
                    checkResult=false;
                }else{
                    item.error=false;
                }
            });

if(!checkResult){
    return false;
}
            projectConsult.company=this.projectData[0].value;
            projectConsult.industry=this.projectData[1].value;
            projectConsult.name=this.projectData[2].value;
            projectConsult.telephone=this.projectData[3].value;
            projectConsult.mail=this.projectData[4].value;
            projectConsult.position=this.projectData[5].value;
            projectConsult.enable=0;
            projectConsult.creator="guangwang";
            let that=this;
            this.http.post("/api/FJ_ProjectConsult/AddProjectConsult",JSON.stringify(projectConsult)).then((result)=>{
            debugger
           let objResult= eval(result);
           let iCode= objResult.code;
           if(iCode==0){

            
                this.$confirm('提交成功' , '提示' , {
                    confirmButtonText:'确认',
                    type:'warning',
                    showCancelButton: false
                    // 重要，设置为true才会把右上角X和取消区分开来            
                    // closeOnClickModal: false
                }).then(()=>{
                    this.projectData[0].value="";
                    this.projectData[1].value="";
                    this.projectData[2].value="";
                    this.projectData[3].value="";
                    this.projectData[4].value="";
                    this.projectData[5].value="";
                })
               
            }
            else{
                that.$message({
                title:'失败',
                message:'...失败',
                type:'fail',
                duration:2000
            })
            }
        });



          // window.open("mailto:fjmarketing@fjctrl.com?subject=项目咨询&body=公司:"+this.projectData[0].value+";行业:"+this.projectData[1].value+";姓名:"+this.projectData[2].value+";电话:"+this.projectData[3].value+";职位:"+this.projectData[5].value);
           // window.open("mailto:"+emailTo+'?cc='+emailCC+'&subject='+emailSub+'&body='+emailBody);

        }
        // projectSubmit(){
        //     debugger
        //     window.open("mailto:fjmarketing@fjctrl.com?subject=项目咨询&body=公司:"+this.projectData[0].value+";行业:"+this.projectData[1].value+";姓名:"+this.projectData[2].value+";电话:"+this.projectData[3].value+";职位:"+this.projectData[5].value);
        //    // window.open("mailto:"+emailTo+'?cc='+emailCC+'&subject='+emailSub+'&body='+emailBody);

        // }
        // page1(index) {
        //     this.$router.push({path:'/productsDetail', query: {switch:2,index}});
        // }
    },
    mounted() {
    /* banner-swiper */
    new Swiper(".banner-swiper", {
      loop: true, // 循环模式选项
      effect: 'fade',
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      // 延迟加载
      lazy: {
        loadPrevNext: true
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });

    let that=this;
        this.http.post("/api/FJ_ProductInfo/GetHomePageProduct",JSON.stringify({})).then((result)=>{
            debugger
           let objResult= eval(result);
           let iCode= objResult.code;
           if(iCode==0){
                that.productsData=objResult.data;
            }
        });
        this.http.post("/api/FJ_Customer/GetHomePageCustomer",JSON.stringify({})).then((result)=>{
            debugger
           let objResult= eval(result);
           let iCode= objResult.code;
           if(iCode==0){
                that.customerData=objResult.data;
            }
        });
    
}
}
</script>

<style scoped>
.inputEmpty{
    border:1px solid red;
}

/* 轮播图 */
/* #swiper { */
    /* height: 600px; */
/* } */
#swiper .banner-swiper {
  width: 100%;
  /* height: 100%; */
}
#swiper .banner-swiper .swiper-slide img {
  width: 100%;
  /* height: 100%; */
  text-align: center;
  /* margin-left: 10%; */
  
}
#swiper .banner-swiper .swiper-slide{
  position: relative;
}
#swiper .banner-swiper .swiper-slide-title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999;
  width: 100%;
  height: 100%;
  color: #fff;
  background:#0AA00A ;
  /* background: rgba(51, 51, 51, 0.534); */
  text-align: center;
  line-height: 80px;
}
#swiper .banner-swiper .swiper-slide-title > h1{
  font-size: 50px;
  margin-top: 12%;
}
#swiper .banner-swiper .swiper-slide-title > p{
  font-size: 20px;
  margin-top: 1%;
  font-weight: 700;
}


#swiper .swiper-button-prev  {
    color:#0AA00A ;
}

#swiper  .swiper-button-next {
    color:#0AA00A ;
}

#swiper .swiper-pagination{
    color:#0AA00A ;
}

.m-3 {
    margin: 30px;
}

.video {
    /* background-color: #00585252;
    height: 200px; */
    width: 100%;
}

.sub-title {
    display: inline-block;
    background-color: #0AA00A;
    color: #fff;
    border-radius: 5px;
    border-top-right-radius: 0;
    font-size: 12px;
    padding: 2px 5px;
}

.title {
    font-size: 20px;
    font-weight: 700;
    margin-top: 5px;
}

.mt-1 {
    margin-top: 10px;
    font-size: 14px;
}

.mt-3 {
    margin-top: 30px;
}

.content {
    margin-top: 10px;
    text-indent: 2rem;
}

.product-item {
    width: 48%;
    margin-bottom: 10px;
}

.product-img {
    background-color: #eee;
    width: 100%;
    height: 100px;
}

.customer-item {
    height: 80px;
    margin-bottom: 10px;
}

.customer-left {
    border-bottom: 1px dashed #0AA00A;
    width: 78%;
}

.customer-right {
    width: 20%;
    background-color: #0AA00A;
    color: #fff;
}

.project-item {
    width: 50%;
    margin-bottom: 30px;
}

.input {
    border-radius: 10px;
    padding: 5px;
    width: 100px;
}
.sub-border {
    border: 1px solid #0AA00A;
    padding: 5px 10px;
    border-radius: 10px;
    color: #0AA00A;
    font-size: 16px;
    font-weight: 700;
}
</style>


// WEBPACK FOOTER //
// src/views/index/m_index.vue